import type { FC } from 'react';

import { Icon } from '@iconify/react';
import { Avatar } from '@mui/material';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { usePopover } from 'src/hooks/use-popover';

import { AccountPopover } from './account-popover';

export const AccountButton: FC = () => {
  const popover = usePopover<HTMLButtonElement>();
  // const { data: userInfoData } = useGetUserInfo({ enabled: false });
  return (
    <>
      <Box
        ref={popover.anchorRef}
        component={ButtonBase}
        onClick={popover.handleOpen}
        sx={{
          alignItems: 'center',
          display: 'flex',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: 'divider',
          height: 40,
          width: 40,
          borderRadius: '50%',
        }}
      >
        <Avatar
          sx={{
            height: 32,
            width: 32,
          }}
          // src={null}
          // src={userInfoData?.data.profile_picture}
        >
          <Icon icon="material-symbols:person-pin" />
        </Avatar>
      </Box>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
